var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSourceConnectors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_24034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.704 60.9568C184.999 47.334 228.344 54.1453 239.489 85.7254",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.254 97.8394L225.71 103.683L211.625 90.3152V64.05L236.02 59.0996L251.254 69.0832V97.8394Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.71 103.683L251.254 97.8394V69.0832M225.71 103.683V74.5071M225.71 103.683L211.625 90.3152V64.05M225.71 74.5071L251.254 69.0832M225.71 74.5071L211.625 64.05M251.254 69.0832L236.02 59.0996L211.625 64.05",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.71 74.5074V103.683L211.625 90.3155V64.0503L225.71 74.5074Z",
    fill: "#F0EEEE",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.88 125.974C191.88 116.002 173.392 120.108 175.09 103.683C176.788 87.2573 219.054 95.633 219.054 81.3911",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.545 43L185.618 62.1742V83.3373L156.202 90.0601L139.935 75.9067L109.437 83.3373L93.9746 71.6607V54.4308L150.545 43Z",
    fill: "#EBF5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.618 62.1742L150.545 43L93.9746 54.4308M185.618 62.1742L156.202 68.4426M185.618 62.1742V83.3373L156.202 90.0601M93.9746 54.4308L109.437 64.0178M93.9746 54.4308V71.6607L109.437 83.3373M109.437 64.0178L139.608 57.3806M109.437 64.0178V83.3373M139.608 57.3806L156.202 68.4426M139.608 57.3806L139.935 75.9067M156.202 68.4426V90.0601M156.202 90.0601L139.935 75.9067M139.935 75.9067L109.437 83.3373",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.407 176.511L213.517 194.087L169.518 158.583V125.631L207.432 117.305L228.027 131.181L264.536 123.318L288.407 137.194V176.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.517 194.087L288.407 176.511V137.194M213.517 194.087V154.159M213.517 194.087L169.518 158.583V125.631M213.517 154.159L288.407 137.194M213.517 154.159L169.518 125.631M288.407 137.194L264.536 123.318L228.027 131.181L207.432 117.305L169.518 125.631",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.517 154.16V194.088L169.518 158.584V125.632L213.517 154.16Z",
    fill: "#FCF9F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.192 155.14C174.104 183.657 153.85 193.981 132.766 196.107",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 9.7126,
    y2: -0.3,
    transform: "matrix(0.263188 -1.03938 -0.901163 -0.187057 69.8296 94.2759)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.28227,
    y2: -0.3,
    transform: "matrix(-0.874332 0.52096 -0.473279 -0.835771 80.748 96.1265)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.17483,
    y2: -0.3,
    transform: "matrix(0.43094 0.867245 -0.906163 0.426016 61.0303 89.4932)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 115.35L67.1397 102.444L97.4681 121.158V149.873L119.981 145.17L151.672 165.682V226.984L41.3284 256.022L11 231.501V115.35Z",
    fill: "#F8EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 115.35L67.1397 102.444L97.4681 121.158M11 115.35L41.3284 132.773M11 115.35V231.501L41.3284 256.022M41.3284 132.773L97.4681 121.158M41.3284 132.773V256.022M97.4681 121.158V149.873M151.672 165.682L97.4681 178.588V149.873M151.672 165.682V226.984L41.3284 256.022M151.672 165.682L119.981 145.17L97.4681 149.873",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3284 132.772L11 115.349V231.5L41.3284 256.021V132.772Z",
    fill: "#F3E6FB",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9746 54.7642L109.437 64.0523L139.796 57.241L156.202 68.3868L185.618 62.1947V83.2479L156.202 90.0593L139.935 75.6874L109.437 83.2479L93.9746 71.6731V54.7642Z",
    fill: "#D8E5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.437 64.0523L93.9746 54.7642V71.6731L109.437 83.2479M109.437 64.0523L139.796 57.241M109.437 64.0523V83.2479M139.796 57.241L156.202 68.3868M139.796 57.241L139.935 75.6874M156.202 68.3868L185.618 62.1947V83.2479L156.202 90.0593M156.202 68.3868V90.0593M156.202 90.0593L139.935 75.6874M139.935 75.6874L109.437 83.2479",
    stroke: "#222222",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_24034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSourceConnectors);
export default __webpack_public_path__ + "static/media/data-source-connectors.fd2004666bbd327c8b1398ea3935d6c2.svg";
export { ForwardRef as ReactComponent };